import App from "app";
import "bootstrap/scss/bootstrap.scss";
import { SnackbarProvider } from "notistack";
import React, { useEffect, useState } from "react";
import { Provider, useDispatch } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./app/store";
import "./index.scss";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "_metronic/_assets/plugins/flaticon/flaticon.css";
import "_metronic/_assets/plugins/flaticon2/flaticon.css";
import "_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import axios from "axios";
import "socicon/css/socicon.css";
import DisabledMember from "./components/disabledMember/DisabledMember";
import { setLocalizationMoment } from "./helper/dateFormat";
import { setLogoImage } from "./services/api/organization";
import LoadingScreen from "./LoadingScreen";
import { FontFamilies } from "theme/fontConfig";

const InitOrg = () => {
  const dispatch = useDispatch();
  const subDomain = window.location.hostname.split(".")[0];
  localStorage.setItem("subDomain", subDomain);
  const organisationKey =
    localStorage.getItem("subDomain") === "localhost"
      ? (process.env.REACT_APP_LOCAL_ORGKEY || "stagerms")
      : localStorage.getItem("subDomain");

  const [origin, setOrigin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [memberPortal, setMemberPortal] = useState(null);

  useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/public/orgbykey/${organisationKey}`
        );

        setOrigin(res);
        localStorage.setItem(
          "getOrginasitionBySubDomain",
          JSON.stringify(res.data)
        );
        localStorage.setItem(
          "allowBillMyAccountOnDonation",
          res?.data?.allowBillMyAccountOnDonation || false
        );
        localStorage.setItem(
          "country",
          JSON.stringify(res?.data?.country || {})
        );
        localStorage.setItem(
          "allowInstallments",
          res?.data?.allowInstallments || false
        );
        localStorage.setItem("orgHasPayment", res?.data?.hasPayment || false);
        localStorage.setItem(
          "paymentMethodCreditCard",
          JSON.stringify(res?.data?.paymentMethodCreditCard)
        );
        localStorage.setItem(
          "paymentMethodAch",
          JSON.stringify(res?.data?.paymentMethodAch)
        );
        localStorage.setItem(
          "memberSetting",
          JSON.stringify(res?.data?.memberSetting || {})
        );
        localStorage.setItem(
          "memberPortalDirectory",
          JSON.stringify(res?.data?.memberPortalDirectory || false)
        );

        setLocalizationMoment(res?.data?.country?.local || "en");
        if (res?.data?.logoImg) dispatch(setLogoImage(res?.data?.logoImg));

        const generalOptions = res?.data?.generalOptions || [];
        const generalOptionsObj = generalOptions.reduce((acc, item) => {
          acc[item.title] = {
            hidden: item.hidden,
            options: item.options,
          };
          return acc;
        }, {});
        const deceasedRelationship =
          res?.data?.deceasedRelationship?.options || [];

        localStorage.setItem(
          "generalOptions",
          JSON.stringify(generalOptionsObj)
        );
        localStorage.setItem(
          "deceasedRelationship",
          JSON.stringify(deceasedRelationship)
        );
        setMemberPortal(Boolean(res?.data?.memberPortal));
      } catch (err) {
        console.error("Failed to fetch org:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchMyAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organisationKey, dispatch]);

  if (loading) {
    let cachedOrg = null;
    try {
      cachedOrg = JSON.parse(
        localStorage.getItem("getOrginasitionBySubDomain")
      );
    } catch (e) {
      cachedOrg = null;
    }
    const logoSrc = cachedOrg?.logoImg || null;

    return <LoadingScreen logoSrc={logoSrc} />;
  }

  if (memberPortal === false) return <DisabledMember />;
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SnackbarProvider
          maxSnack={5}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          style={{ fontFamily: FontFamilies.General }}
        >
          <App />
        </SnackbarProvider>
      </PersistGate>
    </Provider>
  );
};

export default InitOrg;
